import { NocoHttpClient } from '@noco/http-client';
import { createConfigurationWithToken } from '../utils';
var Configuration = NocoHttpClient.Configuration;
var CompanyListApi = /** @class */ (function () {
    function CompanyListApi(basePath, fetchApi) {
        this.basePath = basePath;
        this.fetchApi = fetchApi;
    }
    CompanyListApi.initialize = function (basePath, fetchApi) {
        if (!CompanyListApi.instance) {
            CompanyListApi.instance = new CompanyListApi(basePath, fetchApi);
        }
        return CompanyListApi.instance;
    };
    CompanyListApi.prototype.ApiFactory = function (idToken) {
        var config = createConfigurationWithToken({
            basePath: this.basePath,
            fetchApi: this.fetchApi,
            idToken: idToken,
            type: 'user'
        });
        return new NocoHttpClient.ApiUserV1CompanyListApi(new Configuration(config));
    };
    return CompanyListApi;
}());
export { CompanyListApi };
